// Kamilari tour interface: the parts of the tour chrome that live outside the
// Pano2VR skin. index.html (from kamilari.ggt) creates the player as
// window.pano before this module runs.
import '../css/main.css';
import { mountTourUI } from './tour-ui.js';

// A lazy chunk may import this entry without the template's cache-busting query.
if (window.pano && window.skin && !document.querySelector('.km-tour')) mountTourUI(window.pano, window.skin);
